import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'no-auth-page',
  templateUrl: './no-auth-page.component.html',
  styleUrls: ['./no-auth-page.component.scss'],
  standalone: false,
})
export class NoAuthPageComponent implements OnInit {
  year = new Date().getFullYear()
  constructor(private translate: TranslateService) {}

  get privacyPolicy(): string {
    return this.translate.instant('shared.noAuthPage.privacyPolicy')
  }
  get cookiePolicy(): string {
    return this.translate.instant('shared.noAuthPage.cookiePolicy')
  }
  get termsOfService(): string {
    return this.translate.instant('shared.noAuthPage.termsOfService')
  }
  get securityPolicy(): string {
    return this.translate.instant('shared.noAuthPage.securityPolicy')
  }
  get allRightsReserved(): string {
    return this.translate.instant('shared.noAuthPage.allRightsReserved')
  }

  ngOnInit(): void {}
}
